import { useMemo } from "react";
import { getAverageFeatureValue } from "../utils/raceUtils";

export const useSortedDrivers = (groupDrivers, races, feature, excludePlayoffs, excludeDnf) => {
  return useMemo(() => {
    // Pre-calculate averages once for all drivers (instead of recalculating during each comparison)
    const driversWithAverages = groupDrivers.map(driver => ({
      driver,
      avg: getAverageFeatureValue(races, driver, excludePlayoffs, excludeDnf, feature)
    }));

    // Sort using pre-calculated values
    driversWithAverages.sort((a, b) => {
      const isInvalidA = a.avg === "-" || isNaN(a.avg);
      const isInvalidB = b.avg === "-" || isNaN(b.avg);

      if (isInvalidA && isInvalidB) return 0;
      if (isInvalidA) return 1;
      if (isInvalidB) return -1;

      return feature === "race_pos" || feature === "quali_pos"
        ? a.avg - b.avg
        : b.avg - a.avg;
    });

    // Return just the sorted driver names
    return driversWithAverages.map(item => item.driver);
  }, [groupDrivers, races, feature, excludePlayoffs, excludeDnf]);
};
